import React from "react";
import {
  NavLink,
  Navigate,
  Route,
  Routes,
  useParams,
} from "react-router-dom";

import UfgSettlementsView from "./UfgSettlementsView";
import TfgReportingView from "./TfgReportingView";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSyncAlt } from "@fortawesome/free-solid-svg-icons";

const UfgRegisterView = () => {
  const { viewGuid } = useParams();

  const basePath = `/views/${viewGuid}`;

  return (
    <div className="ufg-register-view">
    <div className="ufg-head">
          Ubezpieczeniowy Fundusz Gwarancyjny
        </div>
    <div className="ufg-wrap">
      <div className="ufg-tabs">
        <NavLink
          to={`${basePath}/settlements`}
          className={({ isActive }) =>
            `ufg-tab ${isActive ? "is-active" : ""}`
          }
        >
          Deklaracje miesięczne
        </NavLink>

        <NavLink
          to={`${basePath}/tfg`}
          className={({ isActive }) =>
            `ufg-tab ${isActive ? "is-active" : ""}`
          }
        >
          Umowy TFG
        </NavLink>
      </div>

      <Routes>
        <Route
          index
          element={<Navigate to={`${basePath}/settlements`} replace />}
        />

        <Route
          path="settlements"
          element={<UfgSettlementsView />}
        />

        <Route
          path="tfg"
          element={<TfgReportingView />}
        />
      </Routes>
       </div>
    </div>
  );
};

export default UfgRegisterView;